
import { defineComponent } from "vue";

type Props = {
  text: string
};

export default defineComponent({
  name: "QuoteTweet",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const twitterWindow = () => {
      let url = `https://twitter.com/share?text=${props.text}&url=${window.location.href}`;
      let width = 575;
      let height = 400;
      let features = "location=no, menubar=no, status=yes, scrollbars=yes, resizable=yes, toolbar=no";
      features += ", left=" + (window.screen.width - width) / 2;
      features += ", width=" + width;
      features += ", top=" + (window.screen.height - height) / 2;
      features += ", height=" + height;

      window.open(url, "_blank", features);
    };
    return {
      twitterWindow
    };
  }
});
